import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import { TEL_PATTERN } from '../../../core/variables';
import { makeStyles } from '@material-ui/core/styles';
import { JAPAN_CODE } from './variables';
import Grid from '@material-ui/core/Grid';
import { TypographyProps } from '@material-ui/core/Typography';
import clsx from 'clsx';
import T from 'i18n-react';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'left',
    '& > *': {
      marginBottom: theme.spacing(1.5),
    },
  },
  typography: {
    fontSize: theme.typography.pxToRem(15),
  },
  container: {
    width: '100%',
    maxWidth: 400,
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: theme.spacing(1.5),
  },
  textField: {
    backgroundColor: theme.palette.common.white,
  },
}));

const PhoneInputField = ({
  messages = [],
  countryCode = { value: '', valid: false },
  phoneNumber = { value: '', valid: false },
}: {
  messages?: Array<React.ReactNode | [React.ReactNode, TypographyProps]>,
  countryCode: {
    value: string,
    valid: boolean,
    onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
  },
  phoneNumber: {
    value: string,
    valid: boolean,
    onChange: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
  },
}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      {messages.map((message, index) => {
        let typoChildren;
        let typoProps = {};
        if (Array.isArray(message)) {
          [typoChildren, typoProps] = message;
        } else {
          typoChildren = message;
        }
        return (
          <Typography
            {...typoProps}
            key={`message${index}`}
            className={clsx(classes.typography, typoProps.className)}
          >
            {typoChildren}
          </Typography>
        );
      })}
      <Typography color="error">
        {T.translate('users.phoneNumbers.warning')}
      </Typography>
      <div className={classes.container}>
        <Grid container alignItems="center" spacing={2}>
          <Grid item xs={4}>
            <TextField
              type="number"
              inputMode="numeric"
              value={countryCode.value}
              error={!countryCode.valid}
              required
              onChange={countryCode.onChange}
              placeholder={JAPAN_CODE.toString()}
              fullWidth
              size="small"
              variant="outlined"
              className={classes.textField}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">+</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={8}>
            <TextField
              type="tel"
              inputMode="tel"
              value={phoneNumber.value}
              error={!phoneNumber.valid}
              required
              inputProps={{ pattern: TEL_PATTERN }}
              placeholder="08012345678"
              size="small"
              variant="outlined"
              fullWidth
              className={classes.textField}
              onChange={phoneNumber.onChange}
              label={T.translate('user.phoneNumber')}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
        </Grid>
      </div>
    </div>
  );
};
export default PhoneInputField;
